"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../../map.component");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("../../../../commons/map.service");
const global_1 = require("../../../../commons/global");
const base_measure_component_1 = require("./base_measure.component");
const measurement_helper_service_1 = require("../../../../service/measurement-helper.service");
const entity_helper_service_1 = require("../../../../service/entity-helper.service");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
const epsg_helper_service_1 = require("../../../../service/epsg-helper.service");
const file_manager_service_1 = require("@src/app/service/file-manager.service");
const Cesium = window.Cesium;
class Attribute {
}
exports.Attribute = Attribute;
class PinViewer extends base_measure_component_1.BaseMeasure {
    // icon:string
    // displayedColumns = ['key', 'value', 'actionsColumn'];
    // @Output() attributeListChange = new EventEmitter<Attribute[]>();
    // categories
    // categoriesSuggestions:object[] = [ {label:'Important'}, {label:'Urgent'}, {label:'Damaged'}, {label:'Good'}, {label:'Bad'}, ];
    // view states
    // viewColors:boolean = false;
    // viewIcons:boolean = false;
    // viewCategories:boolean = true;
    constructor(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager) {
        super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager);
        this.route = route;
        this.router = router;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.applicationEvents = applicationEvents;
        this.epsgHelper = epsgHelper;
        this.fileManager = fileManager;
        console.log('pin.component CONSTRUCTOR', this);
    }
    ngOnInit() {
        // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
        if (this.mapService.scene) {
            this.init();
        }
        else {
            this.addSubscription('pin-sceneChange', this.mapService.onSceneChange('pin.component').subscribe(_ => {
                this.init();
            }));
        }
    }
    init() {
        super.onInit();
    }
    ngOnDestroy() {
        if (this.debug) {
            console.log('line.comp :: ngOnDestroy()');
        }
        try {
            super.onDestroy();
            // this.removeRuntimeLine();
            // this.removeLineInfoEntities();
        }
        catch (e) {
            console.log(e.message);
        }
    }
    /*
      addTagFn(name) {
        return { label: name };
      }
    */
    /*
      onLeftDownClick(movement:any){
        console.log ('down');
      }
      onLeftUpClick(movement:any){
        console.log ('up');
      }
      onMouseMove(movement:any){
        console.log ('move');
      }
    */
    /*
      getScreenShotByAnnotation() {
        if(this.annotation.id){
          this.mapComp.service.V.api('/api/Annotation/' + this.annotation.id + '.files')
            .subscribe(
              value => {
                // alert ( value );
                if (value.length > 0) {
                  this.screenshotName = value[0].name;
                }
              }
            );
        }
      }
    
      deleteScreenShot(canDeleteBytes : boolean) {
        this.deletingScreenShot = true;
        if(this.annotation.id && ( this.screenshotName || this.canDeleteScreenshot)){
          this.mapComp.service.V.api('/api/Annotation/' + this.annotation.id + '/' + this.screenshotName, 'delete')
            .subscribe(
              value => {
                this.screenshotName = undefined;
                if(canDeleteBytes) // to avoid race condition while capturing screenshot
                  this.annotation['screenshotByteCharacters'] = undefined;
                this.deletingScreenShot = false;
              },
              error1 => this.deletingScreenShot = false
            );
        }else{
          this.screenshotByteCharacters = undefined;
        }
    
      }
    */
    /* captureScreenShot() {
       if(this.annotation.id && this.screenshotName){
         this.deleteScreenShot();
       }
       this.openDZIDialogWith(this.attachPhoto, 'TYPES.photo-dzi').subscribe(value => {
         if (value && value.screenshotCaptured && value.screenshotByteCharacters) {
           const reader = new FileReader();
           reader.readAsDataURL(value.screenshotByteCharacters);
           this.annotation['screenshotByteCharacters'] = value.screenshotByteCharacters;
           reader.onloadend = () => {
             this.screenshotByteCharacters = reader.result;
           }
         }
       });
     }*/
    /*
      old_uploadScreenShot(byteCharacters) {
        let d = new Date();
        let imageName = d.getTime() + '.png';
    
        var xhr = new XMLHttpRequest();
        var upload = xhr.upload;
        upload.addEventListener('progress', (evt) => {
          if (evt.lengthComputable) {
          * self.progress = ((self.loaded + evt.loaded) / self.total);
             self.progressSubject.next(self.progress)*
            console.log(evt);
          }
        }, false);
    
        xhr.onreadystatechange = () => {
          if (xhr.readyState === XMLHttpRequest.DONE) {
    
            if (!xhr.responseText || xhr.responseText === '') {
              this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
              return;
            }
            // good response
            var res = JSON.parse(xhr.responseText);
            if (res.status && res.status === 200) {
              {
                this.snackBar.open(Constants.SUCCESS_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
                // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
              }
              console.log('all good');
              // all good
            } else if (res.status && res.status < 400) {
              console.log('vasat error');
              this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
            } else {
              this.snackBar.open(Constants.ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
            }
          }
        };
    
        xhr.open('POST', this.mapComp.fourD.V.config.host + '/api/Annotation/' + this.annotation.id + '/' + imageName);
        xhr.overrideMimeType('application/octet-stream');
        xhr.setRequestHeader('Content-Type', 'application/octet-stream')
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.mapComp.fourD.V.token)
        xhr.send(byteCharacters);
      }
    
      old_addAttrib(){
        this.annotation['attributes'].push({key:'',value:''})
      }
      old_delAttrib(i){
        this.annotation['attributes'].splice(i, 1)
      }
     */
    /* show images either in a tab or a window */
    /*
    showImages(isCameraClicked: boolean) {
      this.mapService.isCameraClicked = isCameraClicked;
      if ( !this.mapComp.viewPhotoBucket ) {
        // this.mapComp.setTab('image');
      } else {
        this.mapComp.openPhotoBucket();
      }
      this.mapComp.setTab('image');
    }
  */
    /*
    Haresh, just copied these from old code, they dont do anything yet
    */
    /*
      openURL(annotation: Annotation) {
        let url: string = '';
        if (!/^http[s]?:\/\//.test(annotation['externalURL'])) {
          url += 'http://';
        }
        url += annotation['externalURL'];
        window.open(url, '_blank');
      }
    
      openExternalLink() {
        var inp = {value: ''}
        if (this.annotation['externalURL']) {
          inp.value = this.annotation['externalURL'];
        }
    
        this.openDialog('MAP.EXTERNAL_LINK', '', null, null, inp, true).subscribe(res => {
          if (res) {
            console.log(res);
            this.annotation['externalURL'] = res;
            this.annotation.saveObservable().subscribe();
          }
        })
      }
    
    
      deleteAttachedPhotos() {
        this.annotation.photoIds = [];
        this.openSnackBarSuccess('Photos detached');
        this.mapService.refreshPhotosFromCurrentCord(this.mapComp).subscribe();
      }
      clearDatum(annotation: Annotation) {
        delete annotation[AppConstants.DATAUM_ASSET]
        annotation.uid = null
    
        annotation.saveObservable().subscribe(succ => {
          this.openSnackBarSuccess('API.' + APITypes.Datum360.NAME + '.CLEARED')
        })
    
      }
    
    */
    searchDatumAssetId(assetId, annotation) {
        this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(global_1.APITypes.Datum360.NAME).id + '/objects/TAGGED_ITEM/id/' + assetId)
            .subscribe(succ => {
            if (succ.error) {
                this.openSnackBarError(succ.error);
            }
            else {
                succ.asset_id = succ.id;
                delete succ.id;
                succ.attrs = Object.keys(succ.attrs).map(a => succ.attrs[a]).filter(a => a.value && a.value != '');
                annotation[global_1.AppConstants.DATAUM_ASSET] = succ;
                annotation.uid = succ.hdl;
                annotation.name = succ.asset_id;
                var coords = annotation.cartographic();
                var href = window.location.href;
                href = href.substring(0, href.indexOf('/search')) + '/search/' + annotation.uid;
                this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(global_1.APITypes.Datum360.NAME).id + '/write', 'post', {
                    tag: assetId,
                    class: succ['clsname'],
                    asset: succ['facility'],
                    coords: 'lat:' + coords.latitude + ' long:' + coords.longitude + ' height:' + coords.height,
                    href: href
                }).subscribe();
                this.mapService.fourD.V.searchByObject(_4d_mapper_1.Annotation)
                    .equals('project', this.mapService.currentProject.id)
                    .equals('active', true)
                    .equals('name', annotation.name)
                    .notEquals('id', annotation.id)
                    .queryObservable()
                    .subscribe(s => {
                    if (s.items.length > 0) {
                        this.openSnackBarError('MAP.DRAWING_EXIST');
                    }
                    else {
                        annotation.saveObservable().subscribe(succ => {
                            this.openSnackBarSuccess('API.' + global_1.APITypes.Datum360.NAME + '.ASSET_FOUND');
                        });
                    }
                });
            }
        }, err => {
            //this.openSnackBarError("API." +  APITypes.Datum360.NAME + ".ASSET_NOT_FOUND")
            console.log('Enter after searching datum');
        });
    }
    browsePhotos() {
        this.openDialogWithModeAndFilterAndMeta({
            project: this.mapService.currentProject
        }, 'file', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT').subscribe(dest => {
            console.log(dest);
            if (dest && Array.isArray(dest) && dest.length > 0) {
                try {
                    if (this.annotation.photoIds) {
                        dest.filter(d => d.dataType && d.dataType.uid === 'photo').map(o => o.transformIds.map(e => this.annotation.photoIds.push(e)));
                        var photos = new Array();
                        // removing duplicate ids
                        this.annotation.photoIds = this.annotation.photoIds.filter(value => {
                            if (photos.indexOf(value) === -1) {
                                photos.push(value);
                                return true;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                    else {
                        this.annotation.photoIds = [];
                        dest.filter(d => d.dataType && d.dataType.uid === 'photo').map(o => o.transformIds.map(e => this.annotation.photoIds.push(e)));
                    }
                    this.refreshPhotosFromCurrentCoord();
                    this.openSnackBarSuccess('PROJECT.DIALOG.PHOTOS_ATTACHED');
                }
                catch (e) {
                    this.openSnackBarSuccess('PROJECT.DIALOG.PHOTOS_ERROR', e.message);
                    console.log(e);
                }
            }
        }, e => this.openSnackBarError(e.message, null));
    }
}
exports.PinViewer = PinViewer;
